import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class InternationalPreviewProxy extends ProxyBase {
  getCompanyDetail(params) {
    return this.get('CompanyDetail', params)
  }

  getProducts(params) {
    return this.get('Products', params)
  }

  getOrderRequest(params) {
    return this.post('OrderRequest', params)
  }
}

export default new InternationalPreviewProxy('InternationalSearch/')
